import { render, staticRenderFns } from "./profileData.vue?vue&type=template&id=8c9813f0"
import script from "./profileData.vue?vue&type=script&lang=js"
export * from "./profileData.vue?vue&type=script&lang=js"
import style0 from "./profileData.vue?vue&type=style&index=0&id=8c9813f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports